@use '../@shared/mixins' as *;
@use '../../styles/global' as *;

@layer kol-component {
	.kol-tree {
		&__treeview-navigation {
			margin: 0;
			padding: 0;
			list-style: none;
		}

		&:focus-within {
			outline: 1px solid;
			outline-offset: 2px;
		}
	}
}
